"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
require("./modal.scss");
var ModalComponentWithoutButton = function (_a) {
    var children = _a.children, open = _a.open, sx = _a.sx;
    return (React.createElement("div", { className: "modal-component" },
        React.createElement(material_1.Modal, { open: open, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description" },
            React.createElement(material_1.Box, { className: "modal-child", sx: sx }, children))));
};
exports.default = ModalComponentWithoutButton;
